// FormField primitive — port of design/v3/SettingsExtraSections.jsx:137-149 FieldRow pattern.
// uppercase label + 컨텐츠 슬롯. error/hint/required 추가.

import type { CSSProperties, ReactNode } from 'react';

export interface FormFieldProps {
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  wide?: boolean;
  children: ReactNode;
  style?: CSSProperties;
}

export function FormField({
  label,
  hint,
  error,
  required,
  wide,
  children,
  style,
}: FormFieldProps) {
  return (
    <div style={{ gridColumn: wide ? '1 / -1' : 'auto', minWidth: 0, ...style }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 600,
          color: 'var(--fg-3)',
          textTransform: 'uppercase',
          letterSpacing: 0,
          marginBottom: 4,
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          minWidth: 0,
        }}
      >
        <span style={{ minWidth: 0, overflowWrap: 'anywhere' }}>{label}</span>
        {required && <span style={{ color: 'var(--danger)' }}>*</span>}
      </div>
      {children}
      {error ? (
        <div
          style={{
            fontSize: 11,
            color: 'var(--danger)',
            marginTop: 4,
            lineHeight: 'var(--lh-body)',
          }}
        >
          {error}
        </div>
      ) : hint ? (
        <div
          style={{
            fontSize: 11,
            color: 'var(--fg-3)',
            marginTop: 4,
            lineHeight: 'var(--lh-body)',
          }}
        >
          {hint}
        </div>
      ) : null}
    </div>
  );
}
